import React, { useEffect } from 'react';
import { redirectAppToUrl } from 'utils';
import { getApiUrl } from 'api/helpers';
import { ApiRoutes } from 'types';
import { CircularProgress, Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'hooks';

export const LoginPage = () => {
  const { state } = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const url = new URL(state?.redirectTo ?? window.location.origin);
    const params = new URLSearchParams(url.search);

    if (!params.has('_gl') && !isAuthenticated) {
      params.append('_gl', 'true');
    }

    redirectAppToUrl(
      `${getApiUrl({ path: ApiRoutes.Login })}?redirectTo=${url}${params.size ? `?${params.toString()}` : ''}`
    );
  }, [state, isAuthenticated]);

  return (
    <Grid container height="100vh">
      <CircularProgress sx={{ m: 'auto auto' }} />
    </Grid>
  );
};
